export const webHostingTopics: string[] = [
    "Web Hosting",
    "Alojamiento Web",
    "Hosting Seguro",
    "Servidor Compartido",
    "Hosting para Empresas",
    "Hosting WordPress",
    "Hosting VPS",
    "Hosting Cloud",
    "Hosting Dedicado",
    "Hosting Escalable",
    "Hosting con SSL",
    "Hosting E-Commerce",
    "Hosting con Base de Datos",
    "Hosting Python",
    "Hosting PHP",
    "Hosting Java",
    "Hosting para APIs",
    "Servidor Web",
    "Apache",
    "Nginx",
    "LiteSpeed"
  ];
  